import { SegmentEventData } from './types';
import { AnalyticEvent } from './events';

const TapToPaySetupCompleted: SegmentEventData = {
  eventName: AnalyticEvent.TapToPaySetupCompleted,
  eventProperties: [],
};

export default TapToPaySetupCompleted;
